import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Topics from './components/Topics';
import Features from './components/Features';
import Index from './components/Index';
import Cards from './components/Cards';
import Carousel from './components/Carousel';
import Comments from './components/Comments';
import AppSection from './components/AppSection';
import Updates from './components/Updates';
import FAQ from './components/FAQ';
import Media from './components/Media';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash;
      setTimeout(() => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Topics />
        <Features />
        <Index />
        <Cards />
        <Carousel />
        <Comments />
        <AppSection />
        <Updates />
        <FAQ />
        <Media />
        <Ranking />
        <Contact />
      </main>
      <Footer />
    </>
  );
}